import React from "react";

import Overview from "./manage/Overview";
import Content from "./DashboardCities";
import DashboardCity from "./manage/DashboardCity";

import {
  CityProvider,
  DashboardLevelProvider,
} from "../../context/levels";

export const CitiesDashboard = () => {
  return (

    <Content />

  );
};

export const Cities = () => {
  return (
    <CityProvider>
      <Overview />
    </CityProvider>
  );
};

export const CityDashboard = () => {
  return (
    <DashboardLevelProvider>
      <DashboardCity />
    </DashboardLevelProvider>
  );
};
